import React, { useEffect } from "react";

import { connect } from "react-redux";

import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

import jsonLogic from 'json-logic-js';
import { filter, get, head, template, templateSettings } from "lodash";

import Copyright from "../../../../components/Copyright";
import Markdown from "../shared/md";
import PageImage from "../shared/PageImage/index";
import { getPageContent } from "../shared/selectors";
import { OUTRO_PAGE } from "../types";
import { gaPageView } from "../../../../utils/analytics";

const styles = theme => ({
  container: {
    padding: "200px 80px 80px 80px",
    [theme.breakpoints.down("xs")]: {
      padding: "80px 24px 24px 24px"
    }
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  image: {
    [theme.breakpoints.up("xl")]: {
      justifyContent: "center"
    }
  },
  content: {
    maxWidth: 450
  }
});

const OutroPage = ({ classes, content, Images, survey, payload, member_id, ext_uuid }) => {
  useEffect(() => {
    gaPageView();
  }, []);

  const { OutroAsset } = Images;

  // Set context object for logic evaluation
  const data = {
    answer: get(payload, 'answer', {}),
    context: get(payload, 'context', {}),
    metadata: { member_id, ext_uuid },
  };

  // Evaluate all redirections and get the first matrch - if any
  const redirections = filter(get(survey, 'triggers', []), { type: 'redirection'});
  const filtered = head(filter(redirections, redirection => jsonLogic.apply(get(redirection, 'logic', false), data)));

  // If a redirection was found render custom page
  // TODO: this should be replaced by supporting logic in pages
  if (filtered) {
    // Interpolate template with values provided
    const output = get(filtered, 'output');
    templateSettings.interpolate = /\${([\s\S]+?)}/g;

    const compiled = template(output);
    const url = compiled({ ext_uuid });

    const panelistContent = `##### Thank you for your response. \n\n\n Click below to go to your panel \n\n\n\n[Click Me](${url} "button")`;
    return (
      <Grid container spacing={16} className={classes.container}>
        <Grid item xs={12} className={classes.contentWrapper}>
          <Markdown content={panelistContent} className={classes.content} />
        </Grid>
        <Grid item xs={12}>
          <Copyright />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} className={classes.contentWrapper}>
        <PageImage
          asset={OutroAsset}
          alt="outro-img"
          className={classes.image}
        />
        <Markdown content={content} className={classes.content} />
      </Grid>
      <Grid item xs={12}>
        <Copyright />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => ({
  content: getPageContent(state, OUTRO_PAGE),

  survey: get(state, ["survey"]),
  payload: get(state, ["payload"]),
  member_id: get(state, ["meta", "member_id"]),
  ext_uuid: get(state, ["meta", "ext_uuid"]),
});

export default connect(mapStateToProps)(withStyles(styles)(OutroPage));
